<div class="nav-pg">
  <div class="justify-content-center" [hidden]="!isLoading">
    <div class="spinner-border t-loader"  role="status">
      <span class="sr-only t-loader-spinner" [class.l-loader]="isLexus==='L'"></span>
    </div>
  </div>
</div>
<div class="handling"> <h1 >{{errMessage}}</h1></div>